module.exports = __webpack_public_path__ + "media/StepsValueHero/MainImage-15ad59b2.svg";